export const systemUrlCarts = 'https://agents.datalogics.co.il/api/rest/';

const fetchCarts = async (postData) => {
    

    try {        
        let systemUrlLocal = systemUrlCarts  + postData.action +  '?token=' + postData.token;

        let body;
        let headers = {};

        body = JSON.stringify(postData);
        headers['Content-Type'] = 'application/json';        

        const response = await fetch(systemUrlLocal, {
            method: 'POST',
            body,
            headers,
            cache: 'no-cache',
            redirect: 'follow',
            referrer: 'no-referrer',
        });

        const result = await response.json();
        return result;
    } catch (err) {
        console.error('Error fetching data:', err);
        return false;
    }
}

export default fetchCarts;